import { render } from "./CatalogView.vue?vue&type=template&id=11cfccf5&scoped=true&ts=true"
import script from "./CatalogView.vue?vue&type=script&lang=ts"
export * from "./CatalogView.vue?vue&type=script&lang=ts"

import "./CatalogView.vue?vue&type=style&index=0&id=11cfccf5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cfccf5"]])

export default __exports__